import * as React from "react";
import {Badge, Button} from "react-bootstrap";
import renderUtils from "../../helpers/renderUtils";

const columns = (t) => [
    {
        field: "machineType",
        label: t ? t("common.machine_type") : "Typ maszyny",
        sort: "desc",
        parent: "machine",
        width: 53,
        type: "enum",
        enumType: "enums/machineType",
    },
    {
        label: t ? t("object_types.machine_model") : "Model maszyny",
        field: "model",
        parent: "machine",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.line") : "Linia",
        field: "packingLineName",
        parent: "machine",
        sort: "desc",
        type: "badge",
        width: 53,
    },
    {
        field: "inventory",
        label: t ? t("menu.inventory") : "Inwentaryzacja",
        sort: "desc",
        width: 53,
        type: "custom",
        custom: function (column, row, history) {
            return <>
                {
                    row.activeFontInventory &&
                    <Badge variant="primary">{t ? t("status.in_progress") : "W trakcie"}</Badge>
                }
                {
                    !row.activeFontInventory && row.lastFontInventory &&

                    <Badge className={"outline-secondary font-max cursor-pointer"}
                            onClick={() => {
                                history.push(`/font/${row.machine.id}/inventory/${row.lastFontInventory}`)
                            }}
                    >
                        {row.lastFontInventoryEndDate}
                    </Badge>
                }
                {
                    !row.activeFontInventory && !row.lastFontInventory &&
                    <Badge variant={"dark"} className={"font-max"}>{t ? t("common.none") : "Brak"}</Badge>
                }
            </>
        }

    },
    {
        field: "exists",
        label: t ? t("common.configured") : "Skonfigurowano",
        sort: "desc",
        width: 53,
        type: "custom",
        custom: function (column, row, history) {
            return <h4>
                {
                    row.exists ?
                        <i className="far fa-check-circle text-primary"></i> :
                        <i className="far fa-times-circle text-secondary"></i>
                }
            </h4>
        }

    }


];

export default columns;